export default window._cmsContent['solar/login']